export enum StorageKeys {
  BEARER_TOKEN = 'bearer-token',
  USER_ID = 'logged-in-user-id',
  EMAIL_ADDRESS = 'logged-in-user-email-address',
  ROUTE = 'current-route'
}